
export const NOTIFICATION_TYPES = {
    TIME_CHANGE: 'time_change',
    PLATE_CHANGE: 'plate_change',
    DRIVER_CHANGE: 'driver_change',
    STATUS_CHANGE: 'status_change',
    RAMP_CHANGE: 'ramp_change',
    NOTE_ADDED: 'note_added'
};

export const NOTIFICATION_LABELS = {
    [NOTIFICATION_TYPES.TIME_CHANGE]: 'Saat Değişikliği',
    [NOTIFICATION_TYPES.PLATE_CHANGE]: 'Plaka Değişikliği',
    [NOTIFICATION_TYPES.DRIVER_CHANGE]: 'Sürücü Değişikliği',
    [NOTIFICATION_TYPES.STATUS_CHANGE]: 'Statü Değişikliği',
    [NOTIFICATION_TYPES.RAMP_CHANGE]: 'Rampa Değişikliği',
    [NOTIFICATION_TYPES.NOTE_ADDED]: 'Mesaj/Not'
};
